import {t} from 'i18next'

export const getGradeValue = (gradeValue: string | null | undefined) => {
	if (!gradeValue) {
		return '-'
	}
	if (gradeValue === 'passed') {
		return t<string>('grade_module.grade.value.passed')
	}
	if (gradeValue === 'failed') {
		return t<string>('grade_module.grade.value.failed')
	}
	return gradeValue
}